import { useEffect, useState } from 'react'
import { CrossIcon } from '../icons'

export interface ModalPropsI {
	open: boolean
	onClick: () => void
}

export const Modal: React.FC<ModalPropsI> = ({ children, open, onClick }) => {
	// const [open, setOpen] = useState<boolean>(false)
	useEffect(() => {
		if (open) document.body.style.overflow = 'hidden'
		return () => {
			if (open) document.body.style.overflow = 'unset'
		}
	}, [open])

	if (!open) return null

	return (
		<>
			<div className='around-wrapper' />
			<div className='modal'>
				<section className='nav-bar'>
					<CrossIcon onClick={onClick} />
				</section>
				{children}
			</div>
		</>
	)
}
